module.exports = __webpack_public_path__ + "static/media/transacao-hotelaria.f965c6da.webp";